import React from 'react';

import IChatOptions from '../../../../interfaces/IChatOptions';
import Tooltip from '../../../Tooltip';
import { FlexContainer, IconButton } from '../../styled';
import { LogoContainer, MainHeader, MainHeaderTitle, StyledEndChat, StyledMinimize } from './ChatHeaderStyles';

interface IChatHeaderProps {
  options: IChatOptions;
  onClickEndChatHandler: () => void;
  onMinimizeHandler: () => void;
  userCanEndChat: boolean;
}

const ChatHeader = (props: IChatHeaderProps) => {
  const { logoUrl, title, primaryAccentColor } = props.options;

  const { onClickEndChatHandler, onMinimizeHandler, userCanEndChat } = props;

  const handleQuit = () => {
    if (userCanEndChat) {
      onClickEndChatHandler();
    } else {
      onMinimizeHandler();
    }
  };

  return (
    <div>
      <MainHeader backgroundColor={primaryAccentColor}>
        <FlexContainer>
          {logoUrl && (
            <LogoContainer>
              <img src={logoUrl} alt='logo' />
            </LogoContainer>
          )}
          <MainHeaderTitle logoProvided={!!logoUrl}>{title}</MainHeaderTitle>
        </FlexContainer>
        <FlexContainer style={{ paddingTop: 8 }}>
          <Tooltip content='Minimize' direction='bottom'>
            <IconButton onClick={onMinimizeHandler} data-testid='minimize-chat'>
              <StyledMinimize />
            </IconButton>
          </Tooltip>
          <Tooltip content='Quit' direction='bottom'>
            <IconButton onClick={handleQuit} data-testid='close-chat'>
              <StyledEndChat />
            </IconButton>
          </Tooltip>
        </FlexContainer>
      </MainHeader>
    </div>
  );
};

export default ChatHeader;
